import * as React from "react";
import isEmpty from "lodash/isEmpty";

import type { CryptopediaArticleType } from "types/cryptopedia";

import { Row, Col } from "components/layout/Grid";

import CryptopediaPost from "components/parts/CryptopediaPost";
import { CryptopediaPostContainer } from "components/parts/CryptopediaPost/style";
import { Heading6 } from "components/parts/Typography/cryptopedia";

interface RelatedPostsProps {
  posts: CryptopediaArticleType[];
}

const RelatedPosts = ({ posts }: RelatedPostsProps) => {
  if (isEmpty(posts)) return null;
  return (
    <React.Fragment>
      <Heading6
        bold
        css={`
          margin-top: 72px;
          margin-bottom: 20px;
        `}
      >
        Up Next
      </Heading6>
      <Row>
        {posts.map((post, index) => {
          if (index > 1) return;
          return (
            <Col md={6} key={post.id}>
              <CryptopediaPostContainer
                css={`
                  margin-top: 0;
                `}
              >
                <CryptopediaPost
                  img={post.featuredImage.url}
                  title={post.title}
                  subtitle={post.subtitle}
                  slug={post.slug}
                />
              </CryptopediaPostContainer>
            </Col>
          );
        })}
      </Row>
    </React.Fragment>
  );
};

export default RelatedPosts;
